<a href="{{docsLink}}" target="_blank" title="Read documentation" class="link"><img src="assets/icons/ic_info.svg"/></a>
